import type { ComponentProps } from "react";
import { Input } from "@/shared/components/shadcn/Input";
import { FieldGroup } from "@/shared/components/ui/FieldGroup";
import { FormField } from "@/shared/components/ui/FormField";
import { Section } from "@/shared/components/ui/Section";
import { LocationAddressFields } from "./LocationAddressFields";

interface LocationSectionProps {
  value: ComponentProps<typeof LocationAddressFields>["value"] & { name: string };
  onChange: (value: LocationSectionProps["value"]) => void;
}

export function LocationSection({ value, onChange }: LocationSectionProps) {
  return (
    <Section title="Location details">
      <FieldGroup>
        <FormField id="location-name" label="Location name">
          <Input required pattern=".*\S.*" title="Enter a location name, not just spaces." value={value.name} onChange={(event) => onChange({ ...value, name: event.target.value })} />
        </FormField>
        <LocationAddressFields value={value} onChange={(address) => onChange({ ...value, ...address })} />
      </FieldGroup>
    </Section>
  );
}
